export var DEFAULT_PREFIX = "spiral_keep_alive";
export var transformPathToSnakeCase = function transformPathToSnakeCase(path, prefix) {
  var _prefix = prefix || DEFAULT_PREFIX;
  var matches = path.match(/[a-zA-Z0-9]+/g) || [];
  var res = matches.join("");
  return "".concat(_prefix, "_").concat(res);
};